//@ts-check
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
/**
 * @param {{ installation: import('./types').MicroserviceInstallationServerStatusState, isResetToDefault: boolean}} props
 */

var AppNote = function AppNote(_ref) {
  var installation = _ref.installation,
      isResetToDefault = _ref.isResetToDefault;
  if (!installation) return null;
  var warning = null;

  if (isResetToDefault) {
    warning = 'Warning! This will remove the data associated with the application. After removing the data, the default version will be installed again.';
  } else {
    if (installation.status === 'UNINSTALLED' || installation.status === 'INSTALL_ERROR') {
      warning = 'The default version of the app will be installed';
    } else if (installation.status === 'INSTALLED' || installation.status === 'UNINSTALL_ERROR' || installation.status === 'UNINSTALLING') {
      warning = 'Warning! This will uninstall all the data associated with the app. After removing the data, you will be able to install the default version again.';
    }
  }

  return React.createElement(Grid, {
    container: true,
    style: {
      maxWidth: 480
    },
    direction: "column",
    spacing: 2
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(Typography, {
    style: {
      marginTop: 8 * 8,
      marginBottom: 8 * 8
    },
    color: "inherit"
  }, warning)));
};

export default AppNote;